export default __webpack_public_path__ + "static/media/arrow-right.1866e7c4.svg";